import { BareActionContext } from 'vuex-typex'
import { AuthState } from '@/store/auth/state'
import { RootState } from '@/store/'
import { IUser } from '@/model/user'
import authStore from '@/store/auth/auth-store'

export default async function authResult(context: BareActionContext<AuthState, RootState>, user: IUser | null): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    if (!user) {
      authStore.commitSetNotAuthenticated()
      return resolve(false)
    } else {
      authStore.commitSetUser({ user: user })
      return resolve(true)
    }
  })
}
